module.exports = __webpack_public_path__ + "static/media/close-button.a075a7f3.svg";